define("shared/components/shared/credentials/basic-display-status/upgrade", ["exports", "@ember/component", "@ember/template-factory", "@ember/service", "@glimmer/component", "@ember/utils", "@ember/debug", "@ember/object"], function (_exports, _component, _templateFactory, _service, _component2, _utils, _debug, _object) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;

  0; //eaimeta@70e063a35619d71f0,"@ember/service",0,"@glimmer/component",0,"@ember/utils",0,"@ember/debug",0,"@ember/object",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--blankWrapper">
    <div class="o--blank">
      <div class={{if @featureImageClass @featureImageClass "img--empty"}}></div>
      {{#if this.needsInstagramProfessional}}
        <h2 class="o--blank__title">
          {{t "shared_phrases.instagram_professional_required.title"}}
        </h2>
        <p>
          {{t "shared_phrases.instagram_professional_required.subtitle" featureName=@featureName}}
        </p>
        <Shared::Link
          class="o--btn o--btn--outline u--m__t"
          data-test-id="setup-business"
          @href="https://docs.later.com/en/articles/2686398-how-to-switch-your-personal-instagram-profile-to-a-business-profile"
          @text={{t "shared_phrases.instagram_professional_required.button"}}
        />
      {{else if this.needsTiktokVerified}}
        <h2 class="o--blank__title">
          {{t "analytics.tiktok.missing_user_verification.title"}}
        </h2>
        <p class="o--blank__desc">
          {{t "analytics.tiktok.missing_user_verification.subtitle"}}
        </p>
        <div
          class="o--btn o--btn--outline u--m__t"
          data-test-id="connect-business"
          {{on "click" this.refreshTiktokToken}}
        >
          {{t "analytics.tiktok.missing_user_verification.button"}}
        </div>
      {{else if this.needsTiktokBusiness}}
        <h2 class="o--blank__title">
          {{t "shared_phrases.tiktok_professional_required.title" featureName=@featureName}}
        </h2>
        <p>
          {{t "shared_phrases.tiktok_professional_required.subtitle_1"}}
          <Shared::Ui::Button
            class="u--text--underline u--p__lr__0"
            @type="unstyled"
            @text={{t "shared_phrases.tiktok_professional_required.action"}}
            @onClick={{this.transitionToSocialSets}}
          />
          {{t "shared_phrases.tiktok_professional_required.subtitle_2"}}
        </p>
        <Shared::Link
          class="o--btn o--btn--outline u--m__t"
          data-test-id="setup-business"
          @href="https://help.later.com/hc/articles/4503280912151"
          @text={{t "shared_phrases.tiktok_professional_required.button"}}
        />
      {{else if this.needsTiktokPermissions}}
        <h2 class="o--blank__title">
          {{t "analytics.tiktok.missing_user_token.title"}}
        </h2>
        <p class="o--blank__desc">
          {{t "analytics.tiktok.missing_user_token.subtitle"}}
        </p>
        <div
          class="o--btn o--btn--outline u--m__t"
          data-test-id="connect-business"
          {{on "click" this.refreshTiktokToken}}
        >
          {{t "analytics.tiktok.missing_user_token.button"}}
        </div>
      {{else}}
        {{#if this.hasUnconnectedProfessional}}
          <h2 class="o--blank__title">
            {{t "shared_phrases.instagram_professional_required.title"}}
          </h2>
        {{else if (or this.needsInstagramRefresh this.expiredProfessionalToken)}}
          <h2 class="o--blank__title">
            {{t "shared_phrases.refresh_required.title"}}
          </h2>
          {{#if (or this.isAccountOwner this.needsFacebookUserToken)}}
            <p class="o--blank__desc">
              {{t "shared_phrases.refresh_required.subtitle" featureName=@featureName profileName=@socialProfile.displayName}}
            </p>
          {{else}}
            <p class="o--blank__desc">
              {{t "shared_phrases.refresh_required.team_member_subtitle" featureName=@featureName profileName=@socialProfile.displayName}}
            </p>
          {{/if}}
        {{else}}
          <h2 class="o--blank__title">
            {{t "shared_phrases.missing_user_token.title"}}
          </h2>
          <p class="o--blank__desc">
            {{t "shared_phrases.missing_user_token.subtitle"}}
          </p>
        {{/if}}
        {{#if (or this.isAccountOwner this.needsFacebookUserToken)}}
          <Shared::Credentials::UpgradeButton
            data-test-id="connect-business"
            @socialProfile={{@socialProfile}}
            @path={{@path}}
            @buttonText={{this.buttonText}}
            class="u--m__t"
          />
        {{else}}
          <Shared::Link
            class="u--text--sm u--m__b__xs"
            @href="https://help.later.com/hc/articles/360043244093-How-to-Refresh-Your-Social-Profile-Connection">
            <Shared::Ui::Button
              @text={{t "shared_phrases.learn_more"}}
              @size="regular"
              @type="outline"
            />
          </Shared::Link>
        {{/if}}
      {{/if}}
    </div>
  </div>
  
  */
  {
    "id": "RB9mTDBR",
    "block": "[[[10,0],[14,0,\"o--blankWrapper\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"o--blank\"],[12],[1,\"\\n    \"],[10,0],[15,0,[52,[30,1],[30,1],\"img--empty\"]],[12],[13],[1,\"\\n\"],[41,[30,0,[\"needsInstagramProfessional\"]],[[[1,\"      \"],[10,\"h2\"],[14,0,\"o--blank__title\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"shared_phrases.instagram_professional_required.title\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,2],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"shared_phrases.instagram_professional_required.subtitle\"],[[\"featureName\"],[[30,2]]]]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[8,[39,2],[[24,0,\"o--btn o--btn--outline u--m__t\"],[24,\"data-test-id\",\"setup-business\"]],[[\"@href\",\"@text\"],[\"https://docs.later.com/en/articles/2686398-how-to-switch-your-personal-instagram-profile-to-a-business-profile\",[28,[37,1],[\"shared_phrases.instagram_professional_required.button\"],null]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"needsTiktokVerified\"]],[[[1,\"      \"],[10,\"h2\"],[14,0,\"o--blank__title\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"analytics.tiktok.missing_user_verification.title\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,2],[14,0,\"o--blank__desc\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"analytics.tiktok.missing_user_verification.subtitle\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[11,0],[24,0,\"o--btn o--btn--outline u--m__t\"],[24,\"data-test-id\",\"connect-business\"],[4,[38,3],[\"click\",[30,0,[\"refreshTiktokToken\"]]],null],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"analytics.tiktok.missing_user_verification.button\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"needsTiktokBusiness\"]],[[[1,\"      \"],[10,\"h2\"],[14,0,\"o--blank__title\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"shared_phrases.tiktok_professional_required.title\"],[[\"featureName\"],[[30,2]]]]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,2],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"shared_phrases.tiktok_professional_required.subtitle_1\"],null]],[1,\"\\n        \"],[8,[39,4],[[24,0,\"u--text--underline u--p__lr__0\"]],[[\"@type\",\"@text\",\"@onClick\"],[\"unstyled\",[28,[37,1],[\"shared_phrases.tiktok_professional_required.action\"],null],[30,0,[\"transitionToSocialSets\"]]]],null],[1,\"\\n        \"],[1,[28,[35,1],[\"shared_phrases.tiktok_professional_required.subtitle_2\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[8,[39,2],[[24,0,\"o--btn o--btn--outline u--m__t\"],[24,\"data-test-id\",\"setup-business\"]],[[\"@href\",\"@text\"],[\"https://help.later.com/hc/articles/4503280912151\",[28,[37,1],[\"shared_phrases.tiktok_professional_required.button\"],null]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"needsTiktokPermissions\"]],[[[1,\"      \"],[10,\"h2\"],[14,0,\"o--blank__title\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"analytics.tiktok.missing_user_token.title\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,2],[14,0,\"o--blank__desc\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"analytics.tiktok.missing_user_token.subtitle\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[11,0],[24,0,\"o--btn o--btn--outline u--m__t\"],[24,\"data-test-id\",\"connect-business\"],[4,[38,3],[\"click\",[30,0,[\"refreshTiktokToken\"]]],null],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"analytics.tiktok.missing_user_token.button\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"hasUnconnectedProfessional\"]],[[[1,\"        \"],[10,\"h2\"],[14,0,\"o--blank__title\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"shared_phrases.instagram_professional_required.title\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,5],[[30,0,[\"needsInstagramRefresh\"]],[30,0,[\"expiredProfessionalToken\"]]],null],[[[1,\"        \"],[10,\"h2\"],[14,0,\"o--blank__title\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"shared_phrases.refresh_required.title\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"],[41,[28,[37,5],[[30,0,[\"isAccountOwner\"]],[30,0,[\"needsFacebookUserToken\"]]],null],[[[1,\"          \"],[10,2],[14,0,\"o--blank__desc\"],[12],[1,\"\\n            \"],[1,[28,[35,1],[\"shared_phrases.refresh_required.subtitle\"],[[\"featureName\",\"profileName\"],[[30,2],[30,3,[\"displayName\"]]]]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],[[[1,\"          \"],[10,2],[14,0,\"o--blank__desc\"],[12],[1,\"\\n            \"],[1,[28,[35,1],[\"shared_phrases.refresh_required.team_member_subtitle\"],[[\"featureName\",\"profileName\"],[[30,2],[30,3,[\"displayName\"]]]]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]]]],[]],[[[1,\"        \"],[10,\"h2\"],[14,0,\"o--blank__title\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"shared_phrases.missing_user_token.title\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,2],[14,0,\"o--blank__desc\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"shared_phrases.missing_user_token.subtitle\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]],[]]],[41,[28,[37,5],[[30,0,[\"isAccountOwner\"]],[30,0,[\"needsFacebookUserToken\"]]],null],[[[1,\"        \"],[8,[39,6],[[24,\"data-test-id\",\"connect-business\"],[24,0,\"u--m__t\"]],[[\"@socialProfile\",\"@path\",\"@buttonText\"],[[30,3],[30,4],[30,0,[\"buttonText\"]]]],null],[1,\"\\n\"]],[]],[[[1,\"        \"],[8,[39,2],[[24,0,\"u--text--sm u--m__b__xs\"]],[[\"@href\"],[\"https://help.later.com/hc/articles/360043244093-How-to-Refresh-Your-Social-Profile-Connection\"]],[[\"default\"],[[[[1,\"\\n          \"],[8,[39,4],null,[[\"@text\",\"@size\",\"@type\"],[[28,[37,1],[\"shared_phrases.learn_more\"],null],\"regular\",\"outline\"]],null],[1,\"\\n        \"]],[]]]]],[1,\"\\n\"]],[]]],[1,\"    \"]],[]]]],[]]]],[]]]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"@featureImageClass\",\"@featureName\",\"@socialProfile\",\"@path\"],false,[\"if\",\"t\",\"shared/link\",\"on\",\"shared/ui/button\",\"or\",\"shared/credentials/upgrade-button\"]]",
    "moduleName": "shared/components/shared/credentials/basic-display-status/upgrade.hbs",
    "isStrictMode": false
  });

  let Upgrade = (_dec = (0, _service.inject)('social/instagram-business'), (_class = class Upgrade extends _component2.default {
    get isAccountOwner() {
      var _this$auth$currentUse;

      return (_this$auth$currentUse = this.auth.currentUserModel) === null || _this$auth$currentUse === void 0 ? void 0 : _this$auth$currentUse.isAccountOwner;
    }

    get isInstagram() {
      var _this$auth$socialProf;

      return (_this$auth$socialProf = this.auth.socialProfile) === null || _this$auth$socialProf === void 0 ? void 0 : _this$auth$socialProf.isInstagram;
    }

    get isTiktok() {
      var _this$auth$socialProf2;

      return (_this$auth$socialProf2 = this.auth.socialProfile) === null || _this$auth$socialProf2 === void 0 ? void 0 : _this$auth$socialProf2.isTiktok;
    }

    get hasUnconnectedBusiness() {
      return this.isInstagram && this.instagramBusiness.hasUnconnectedBusiness;
    }

    get needsInstagramProfessional() {
      return this.isInstagram && this.instagramBusiness.needsProfessional;
    }

    get needsTiktokBusiness() {
      var _this$auth$currentSoc;

      return this.isTiktok && !((_this$auth$currentSoc = this.auth.currentSocialProfile) !== null && _this$auth$currentSoc !== void 0 && _this$auth$currentSoc.isTiktokBusinessApiAccount);
    }

    get needsTiktokVerified() {
      var _this$auth$currentSoc2;

      return this.isTiktok && ((_this$auth$currentSoc2 = this.auth.currentSocialProfile) === null || _this$auth$currentSoc2 === void 0 ? void 0 : _this$auth$currentSoc2.isTiktokUnverifiedAccount);
    }

    get needsTiktokPermissions() {
      var _this$auth$currentSoc3;

      return this.isTiktok && !((_this$auth$currentSoc3 = this.auth.currentSocialProfile) !== null && _this$auth$currentSoc3 !== void 0 && _this$auth$currentSoc3.hasTiktokAnalyticsScope);
    }

    get needsInstagramRefresh() {
      return this.isInstagram && this.instagramBusiness.needsRefresh;
    }

    get needsFacebookUserToken() {
      return this.isInstagram && this.instagramBusiness.needsFacebookUserToken;
    }

    get buttonText() {
      if (this.needsFacebookUserToken) {
        return this.intl.t('shared_words.refresh');
      } else if (this.needsInstagramRefresh && this.isAccountOwner) {
        return this.intl.t('shared_words.refresh');
      } else if (this.needsInstagramRefresh) {
        return this.intl.t('shared_phrases.learn_more');
      }

      return '';
    }

    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "tiktok", _descriptor2, this);

      _initializerDefineProperty(this, "instagramBusiness", _descriptor3, this);

      _initializerDefineProperty(this, "intl", _descriptor4, this);

      _initializerDefineProperty(this, "router", _descriptor5, this);

      this._verifyAttrs();
    }

    refreshTiktokToken() {
      this.tiktok.loginWithBusinessApiAccount(this.auth.currentSocialProfile);
    }

    transitionToSocialSets() {
      this.router.transitionTo('account.groups');
    }

    _verifyAttrs() {
      (false && !((0, _utils.isPresent)(this.args.featureName)) && (0, _debug.assert)('A `@featureName` argument must be provided', (0, _utils.isPresent)(this.args.featureName)));
      (false && !(typeof this.args.featureName === 'string') && (0, _debug.assert)('The `@featureName` argument must be a string', typeof this.args.featureName === 'string'));
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "tiktok", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "instagramBusiness", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "refreshTiktokToken", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "refreshTiktokToken"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "transitionToSocialSets", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "transitionToSocialSets"), _class.prototype)), _class));
  _exports.default = Upgrade;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, Upgrade);
});